import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { filterNavsByRole, filterNavsBymodel, filterNavsByPanel } from "core/navsfilters";
import { useContext } from "react";
import AuthContext from "context/AuthContext";

const NavBreadcrumb = (
  {
    navs,
    bread,
  }
) => {
  const [t] = useTranslation("routes")
  const { user, panel } = useContext(AuthContext);

  const filteredNavsPanel = filterNavsByPanel(navs, panel);
  const filteredNavsUser = filterNavsByRole(filteredNavsPanel, user);
  const filteredNavsModel = filterNavsBymodel(filteredNavsUser, user);

  return (
    <>
      <div className="row navcrumb position-fixed" style={{ zIndex: "10" }}>
        <div className="col-12 p-0">
          <div className=" breadcrumb d-flex justify-content-between">
            <div className="nav">
              {
                filteredNavsModel.map((item, idx) =>
                  <div className="nav-item " key={idx}>
                    <Link
                      to={item.url}
                      data-rr-ui-event-key={item.url}
                      className={`nav-link ${window.location.pathname === item.url ? 'active' : ''}`}>
                      {t(item.name)}
                    </Link>
                  </div>
                )
              }
            </div>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/" data-rr-ui-event-key="/" className="nav-link "><FontAwesomeIcon icon="house" /></Link>
              </li>
              {
                bread.map((item, idx) => {
                  return item.current ? (
                    <li className="breadcrumb-item active" aria-current="page" key={idx}>{item.name}</li>
                  ) : (
                    <li className="breadcrumb-item" key={idx}><Link to={item.url}>{item.name}</Link></li>
                  );
                })
              }
            </ol>
          </div>
        </div>
      </div>
      <div className="row" style={{ height: "32px" }}></div>
    </>


  );
}
export default NavBreadcrumb